import { onBeforeUnmount, ref, Ref, watch } from 'vue';

/** A copy of `source` that updates once `source` has been stable for `wait` milliseconds. */
export function useDebouncedRef(source: Ref<string>, wait: number): Ref<string> {
    const debounced = ref(source.value);
    let timer: number | undefined;

    watch(source, (value) => {
        clearTimeout(timer);
        timer = window.setTimeout(() => {
            debounced.value = value;
        }, wait);
    });

    onBeforeUnmount(() => clearTimeout(timer));

    return debounced;
}
